import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { formatDistance, formatDuration } from '@shopDetails/utils/pickup';
import { Container, Column, Label, Text, Loading } from '../components';
import messages from './messages';

const Pickup = ({ intl: { formatMessage }, info, loading }) => (
  <Container>
    <Column>
      <Label>{formatMessage(messages.getIn)}</Label>
      <Text>
        {loading && <Loading />}
        {!loading && (
          <FormattedMessage {...messages.time} values={info?.time} />
        )}
      </Text>
    </Column>
    <Column>
      <Label>{formatMessage(messages.distance)}</Label>
      <Text>{formatDistance(info.distance)}</Text>
    </Column>
    <Column>
      <Label>{formatMessage(messages.walking)}</Label>
      <Text>{formatDuration(info.duration)}</Text>
    </Column>
  </Container>
);

Pickup.propTypes = {
  info: PropTypes.shape({
    time: PropTypes.shape({
      maxMinutes: PropTypes.number,
    }),
    distance: PropTypes.number,
    duration: PropTypes.number,
  }),
  intl: intlShape.isRequired,
  loading: PropTypes.bool,
};

export default memo(injectIntl(Pickup));
